import { Venue } from "common/types";
import { atom, useAtom } from "jotai";

const selectedVenueAtom = atom<Venue | null>(null as Venue | null);

export function useSelectedVenue() {
  const [selectedVenue, setSelectedVenue] = useAtom(selectedVenueAtom);
  return {
    selectedVenue,
    setSelectedVenue,
  };
}
